import { api } from './client';

export interface ConfigItem {
  chave: string;
  valor?: string;
  descricao?: string;
  escopo?: string;
}

export async function listSistema(): Promise<ConfigItem[]> {
  const { data } = await api.get<ConfigItem[]>('/config/sistema');
  return data;
}

export async function putSistema(chave: string, valor: string): Promise<ConfigItem> {
  const { data } = await api.put<ConfigItem>(`/config/sistema/${encodeURIComponent(chave)}`, { valor });
  return data;
}

export async function listEmitenteConfig(emitenteId: number): Promise<ConfigItem[]> {
  const { data } = await api.get<ConfigItem[]>(`/config/emitente/${emitenteId}`);
  return data;
}

export async function putEmitenteConfig(emitenteId: number, chave: string, valor: string): Promise<ConfigItem> {
  const { data } = await api.put<ConfigItem>(
    `/config/emitente/${emitenteId}/${encodeURIComponent(chave)}`,
    { valor }
  );
  return data;
}

export async function smtpTest(destinatario: string): Promise<{ ok: boolean; detail?: string }> {
  const { data } = await api.post('/config/smtp/test', { to: destinatario, destinatario });
  return data;
}
